import React, { useMemo } from "react";
import { DataTable } from 'primereact/datatable';
import { countryList } from "../../components/Conteries";
import { Column } from 'primereact/column';
import Config from "../../Config.js";
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';


export const BestsCityallshow = ({ LocationsCitywisecanningdata }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        if (rowData?.qrcodeType === "personalqrcode") {
            return (<img
                src="../assets/img/mtsttqr.png"
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>)
        }
        else {
            return (
                <img
                    src={FullPath}
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                        //currentTarget.src = "../assets/img/mtsttqr.png";
                    }}
                ></img>

            );
        }

    };
    return (

        <DataTable
            value={LocationsCitywisecanningdata}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={LocationsCitywisecanningdata ? LocationsCitywisecanningdata?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="countryName"
                header="Country"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="cityName"
                header="City"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Image"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productImageBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />



            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const BestperformingVendordetail = ({ DatatableVendordetailsWiseList }) => {

    const vendorLogoBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.vendorLogo}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>
        )

    };
    const productLogoBodyTemplate = (rowData) => {
        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>
        )

    };
    return (

        <DataTable
            value={DatatableVendordetailsWiseList}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={DatatableVendordetailsWiseList ? DatatableVendordetailsWiseList?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="vendorName"
                header="Vendor Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Logo"
                header="Logo"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={vendorLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />

            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Pic"
                header="Pic"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={vendorLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />


            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const BestScanLabelDetlisisall = ({ Lablewisecanning }) => {
    const productLogoBodyTemplate = (rowData) => {
        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>
        )

    };
    return (

        <DataTable
            value={Lablewisecanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Lablewisecanning ? Lablewisecanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="lableName"
                header="Lable"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Logo"
                header="Logo"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const Subbcattegorywisescanningtable = ({ Subbcattegorywisescanning }) => {

    const productLogoBodyTemplate = (rowData) => {
        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return rowData?.qrcodeType === "personalqrcode" ? (
            <>
                <img
                    src="../assets/img/mtsttqr.png"
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        ) : (
            <>
                <img
                    src={FullPath}
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        );

    };
    return (

        <DataTable
            value={Subbcattegorywisescanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Subbcattegorywisescanning ? Subbcattegorywisescanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="subCategoryName"
                header="Main category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="categoryName"
                header="Sub category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Image"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const CategorywisescanningDetails = ({ Categorywisescanning, togglecategorydetail }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        togglecategorydetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    return (

        <DataTable
            value={Categorywisescanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Categorywisescanning ? Categorywisescanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="categoryName"
                header="Main category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="subCategoryName"
                header="Sub category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="representative.name"
                header="Actions"
                style={{
                    width: '2%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                }}
                headerStyle={{ background: '#f2f2f2' }}
                body={buttonTemplate}
            />
        </DataTable>
    )
};

//Article reports

export const Locationscitywisescans = ({ LocationsCitywisecanning }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return rowData?.qrcodeType === "personalqrcode" ? (
            <>
                <img
                    src="../assets/img/mtsttqr.png"
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        ) : (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                    //currentTarget.src = "../assets/img/mtsttqr.png";
                }}
            ></img>
        );
    };
    return (

        <DataTable
            value={LocationsCitywisecanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={LocationsCitywisecanning ? LocationsCitywisecanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '7%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="countryName"
                header="Country"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="cityName"
                header="City"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Pic"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productImageBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const Bestperforminglabeldetail = ({ Lablewisecanning }) => {
    const productLogoBodyTemplate = (rowData) => {
        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>
        )

    };
    return (

        <DataTable
            value={Lablewisecanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Lablewisecanning ? Lablewisecanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="lableName"
                header="Lable"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Logo"
                header="Logo"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

//Production reports

export const ProductionLocationscitywisescans = ({ LocationsCitywisecanning }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return rowData?.qrcodeType === "personalqrcode" ? (
            <>
                <img
                    src="../assets/img/mtsttqr.png"
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        ) : (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                    //currentTarget.src = "../assets/img/mtsttqr.png";
                }}
            ></img>
        );
    };
    return (

        <DataTable
            value={LocationsCitywisecanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={LocationsCitywisecanning ? LocationsCitywisecanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="countryName"
                header="Country"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="cityName"
                header="City"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Pic"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productImageBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const ProductionBestperformingVendordetail = ({ DatatableVendordetailsWiseList }) => {

    
    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return (<img
            src={FullPath}
            style={{ height: "50px" }}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "../assets/img/noimage.jpg";
                //currentTarget.src = "../assets/img/mtsttqr.png";
            }}
        ></img>)
    };

    const vendorLogoTemplate= (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.vendorLogo}`;
        return (<img
            src={FullPath}
            style={{ height: "50px" }}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "../assets/img/noimage.jpg";
                //currentTarget.src = "../assets/img/mtsttqr.png";
            }}
        ></img>)
    };
    return (

        <DataTable
            value={DatatableVendordetailsWiseList}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={DatatableVendordetailsWiseList ? DatatableVendordetailsWiseList?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="vendorName"
                header="Vendor Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />

            <Column
                field="Image"
                header="Logo"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={vendorLogoTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />

            <Column
                field="Image"
                header="Pic"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productImageBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />



            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};


//Personal reports

export const PersonalLocationscitywisescans = ({ LocationsCitywisecanning }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return rowData?.qrcodeType === "personalqrcode" ? (
            <>
                <img
                    src="../assets/img/mtsttqr.png"
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        ) : (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                    //currentTarget.src = "../assets/img/mtsttqr.png";
                }}
            ></img>
        );
    };
    return (

        <DataTable
            value={LocationsCitywisecanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={LocationsCitywisecanning ? LocationsCitywisecanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="countryName"
                header="Country"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="cityName"
                header="City"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Pic"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productImageBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

export const PersonalCategorywisescanningDetails = ({ Categorywisescanning, togglecategorydetail }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        togglecategorydetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    return (

        <DataTable
            value={Categorywisescanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Categorywisescanning ? Categorywisescanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="categoryName"
                header="Main category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="subCategoryName"
                header="Sub category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="representative.name"
                header="Actions"
                style={{
                    width: '2%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                }}
                headerStyle={{ background: '#f2f2f2' }}
                body={buttonTemplate}
            />
        </DataTable>
    )
};

export const PersonalSubbcattegorywisescanningtable = ({ Subbcattegorywisescanning }) => {

    const productLogoBodyTemplate = (rowData) => {
        let FullPath = `${Config.contentUrl + rowData.productImagepath}`;
        return rowData?.qrcodeType === "personalqrcode" ? (
            <>
                <img
                    src="../assets/img/mtsttqr.png"
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        ) : (
            <>
                <img
                    src={FullPath}
                    style={{ height: "50px" }}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "../assets/img/noimage.jpg";
                    }}
                ></img>
            </>
        );

    };
    return (

        <DataTable
            value={Subbcattegorywisescanning}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50]}
            tableStyle={{ minWidth: '45rem' }}
            totalRecords={Subbcattegorywisescanning ? Subbcattegorywisescanning?.length : 0}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="justify-content-end"
            stripedRows
            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
            <Column
                field="sr"
                header="Sr #"
                style={{
                    width: '5%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 10px',
                    textAlign: 'center',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="subCategoryName"
                header="Main category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="categoryName"
                header="Sub category"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="productName"
                header="QR Code Name"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="Image"
                header="Image"
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',
                    fontWeight: "600"

                }}
                body={productLogoBodyTemplate}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
            <Column
                field="totalScanCount"
                header="Total Scans"
                sortable
                style={{
                    width: '25%',
                    border: '1px solid #e4e7ea',
                    padding: '25px 15px',

                }}
                headerStyle={{ background: '#f2f2f2' }}
                bodyStyle={{ textAlign: 'center' }}
            />
        </DataTable>
    )
};

